<template>
  <div
    v-if="!loading"
    class="files-table-wrapper"
  >
    <div class="default-table m-0 shadow-none">
      <b-table-simple
        class="loaded"
        table-class="mt-0 border-0"
        selectable
        small
        responsive
        tbody-tr-class="files-table"
      >
        <b-thead>
          <b-tr>
            <b-th class="table-select-col" />
            <b-th class="table-primary-col">
              Folder
            </b-th>
          </b-tr>
        </b-thead>
        <b-tbody>
          <b-tr
            v-if="parents"
            class="files-table cursor-pointer"
            :variant="isRowSelected({ key: parentKey }) ? 'blue' : ''"
            @click="selectRow({ key: parentKey })"
          >
            <b-td class="dir-table-select-col">
              <select-button
                :key="value ? value.key : parentKey"
                class="cursor-pointer"
                :selected="isRowSelected({ key: parentKey })"
              />
            </b-td>
            <b-td colspan="4">
              <GjIcon name="ArrowUpAlt" />
              <span class="ml-1">Up one level </span>
            </b-td>
          </b-tr>
          <template>
            <b-tr
              v-for="item in content"
              :key="item.key"
              class="files-table cursor-pointer"
              :variant="isRowSelected(item) ? 'blue' : ''"
              @click="selectRow(item)"
            >
              <b-td class="dir-table-select-col">
                <select-button
                  :key="value ? value.key : 0"
                  class="cursor-pointer"
                  :selected="isRowSelected(item)"
                />
              </b-td>
              <b-td class="dir-table-primary-col">
                <div class="d-flex flex-column">
                  <div
                    class="d-flex align-items-center overflow-visible position-relative"
                  >
                    <a
                      v-if="item.isFolder"
                      class="file-icon text-main"
                    >
                      <GjIcon name="Folder" />
                    </a>
                    <a
                      v-else
                      class="file-icon text-main"
                    >
                      <GjIcon name="File" />
                    </a>
                    <a class="ml-1 object-name text-truncate">
                      {{ formatObjectName(item.key) }}
                    </a>
                  </div>
                </div>
              </b-td>
            </b-tr>
          </template>
        </b-tbody>
      </b-table-simple>
    </div>
  </div>
  <div
    v-else
    class="text-center py-4"
  >
    <b-spinner />
  </div>
</template>

<script>
import StorageHelpers from '@/mixins/storage-helpers'

export default {
  name: 'AvailableDirectories',
  components: {},
  mixins: [StorageHelpers],
  props: {
    value: {
      type: Object,
      default: null,
    },
    parents: {
      type: Array,
      default: null,
    },
    objectsToMove: {
      type: Array,
      default: null,
    },
    accountId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      gettingDirectories: true,
      loading: false,
    }
  },
  computed: {
    content() {
      return this.$store.state.accountObjects.directories.filter(
        obj => !this.objectsToMove?.some(o => o.key === obj.key),
      )
    },
    parentKey() {
      if (this.parents.length > 1) {
        return this.path
      }
      return '/'
    },
    path() {
      let path = ''
      for (let i = 0; i < this.parents.length - 1; i++) {
        path += `${this.parents[i]}/`
      }
      return path
    },
  },
  created() {
    this.getDirectories()
  },
  beforeDestroy() {
    this.$emit('input', null)
  },
  methods: {
    getDirectories() {
      this.loading = true
      this.$store
        .dispatch('accountObjects/getAllDirectories', this.accountId)
        .then(() => {
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    isRowSelected(item) {
      if (this.value) return this.value.key === item.key
      return false
    },
    selectRow(item) {
      if (!this.isRowSelected(item)) {
        this.$emit('input', item)
      } else {
        this.$emit('input', null)
      }
    },
  },
}
</script>

<style scoped>
.default-table {
  margin-bottom: 0;
  border-bottom: none;
}
</style>
